import { FormHelperText } from "@material-ui/core";
import React, { useEffect } from "react";
import { formatToCurrencyString } from "../../../../../../helpers";
import auth from "../../../../../../store/modules/auth";
import MySimpleMenu from "../../../../../System/FormComponents/MySimpleMenu";
import { useGetAccounts } from "../hooks/useGetAccounts";

const ToAccount = ({ form, account }): any => {
  const { options, isLoading } = useGetAccounts({
    account,
    form,
  });

  const makeOptionString = (a) => {
    return (
      <span>
        {a.currencyId} <b>{a.shortNumber}</b>,{" "}
        {formatToCurrencyString(a.availableBalance, a.currencyId)}
      </span>
    );
  };

  const { setValue } = form;

  useEffect(() => {
    if (options?.length === 1) {
      setTimeout(() => setValue("toAccountId", options[0].accountId), 0);
    }
  }, [setValue, options]);

  if (!options) {
    return null;
  }

  if (options?.length === 0 && !isLoading) {
    return (
      <p className="font-bold text-red-600 border-b-2 border-gray-200 py-1">
        {`This client doesn't have second account in ${account.currencyId}`}
      </p>
    );
  }

  if (options?.length === 1 && !isLoading) {
    const a = options[0];
    return (
      <div className="flex flex-col mt-2 mb-2 border-b-2 border-gray-200 py-1">
        <span className="text-md">
          To account: {a.currencyId} <b>{a.number}</b>
        </span>
        <span>
          Available balance:{" "}
          <b>{formatToCurrencyString(a.availableBalance, a.currencyId)}</b>
        </span>
      </div>
    );
  }

  return (
    !isLoading && (
      <div className="w-full">
        <MySimpleMenu
          {...form}
          name="toAccountId"
          disabled={!!auth.profile && !auth.profile?.isAdmin}
          rules={{ required: true }}
          fullWidth
          label={`Select beneficiary’s account*`}
          renderOption={makeOptionString}
          options={
            options?.map((item) => ({ ...item, value: item.accountId })) || []
          }
        />

        {form?.formState?.errors?.toAccountId?.type === "required" && (
          <FormHelperText error>Field is required</FormHelperText>
        )}
      </div>
    )
  );
};

export default ToAccount;
